/* eslint-disable eqeqeq */

import axios from 'axios';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const dropdownMapper = res => res.data.map(el =>
    ({
        value: el.id,
        key: el.id,
        additional: el.studyProgramStatus ? el.studyProgramStatus._key : el.id,
        text: (
            ((window.$locale !== 'bs' && window.$locale !== 'hr') && el.translations.length)
                ? el.translations.find(e => e.language === window.$locale).name
                : el.studyProgramBasic
                    ? el.studyProgramBasic.name + ' | ' + el.name
                    : el.name)
    }));
const dropdownMapperName = res => res.data.map(el => ({ value: el.name, key: el.id, text: (((window.$locale !== 'bs' && window.$locale !== 'hr') && el.translations.length) ? el.translations.find(e => e.language === window.$locale).name : el.name) }));

const fetchCommitteeTypes = () => axios.get('/committee/types')
    .then(dropdownMapperName)
    .catch(err => {
        console.log('Failed to fetch committee types.');
    });

const fetchAcademicYears = () => axios.get('/academic-years/current-and-previous/')
    .then(dropdownMapper)
    .catch(err => {
        console.log('Failed to fetch academic years.');
    });

let emptyObj = {};
const fetchMembersOptions = () => axios.post('/employees/by-key/allWithNonAcademic', emptyObj)
    .then(res => {
        let members = res.data.map(el => ({
            value: {
                value: el.id,
                key: el.id,
                employeeId: el.id,
                text: el.firstName + ' ' + el.lastName
            },
            key: el.id,
            text: el.firstName + ' ' + el.lastName
        }));
        return members;
    })
    .catch(err => {
        console.log('Failed to fetch employees.');
    });

const fetchCommittees = () => axios.get('/committee')
    .then(res => res.data.valueOf());


const fetchCommitteeOptions = () => axios.get('/committee/by-org-unit')
    .then(res => res.data.map(el => {
        let headObj = el.committeeMembers.find((e) => e.committeeMemberTypeKey === 'predsjednik');
        let headName = headObj.firstName + ' ' + headObj.lastName;
        return {
            value: el.id,
            key: el.id,
            committeeMembers: el.committeeMembers,
            text: el.committeeType + ' | ' + el.academicYear + ' | ' + headName
        };
    })).catch(err => {
        console.log('Failed to fetch all committee.');
    });


const fetchCommitteeMembersByCommitteeId = (committeeId) => axios.get(`/committee/${committeeId}/members`)
    .then(res => {
        let members = res.data;
        return members;
    });
const fetchCommitteeCandidatesByCommitteeId = (committeeId) => axios.get(`/committee/${committeeId}/candidates`)
    .then(res => {
        let candidates = res.data;
        return candidates;
    });

const fetchCommitteeInfoByCommitteeId = (committeeId) => axios.get(`/committee/${committeeId}`)
    .then(res => {
        let info = res.data;
        return info;
    });


const fetchCandidates = () => axios.get('/equivalence')
    .then(res => {
        let candidates = res.data;
        return candidates;
    });

const fetchCandidateOptions = () => axios.get('/equivalence')
    .then(res => res.data.map(el => ({
        value: 5,
        key: 5,
        text: el.firstName + ' ' + el.lastName
    })));


const addCandidatesToCommitteeByCommitteeId = (candidateId, obj) => axios.post(`/equivalence/${candidateId}`, obj)
    .then(res => res.data.valueOf());


const createCandidate = (obj) => axios.post('/equivalence', obj)
    .then(res => res.data);


const createCandidateFromUNSA = (obj) => axios.post('/equivalence/from-unsa', obj)
    .then(res => res.data)
    .catch(err => {
        console.log('Failed to create UNSA candidate.');
    });

const createCommittee = (obj) => axios.post('/committee', obj)
    .then(res => res.data);


const fetchStudyProgramsActive = () => axios.get('/study-programs/by-faculty/active')
    .then(dropdownMapper).catch(err => {
        console.log('Failed to fetch study programs.');
    });

const fetchSemesterOptions = () => axios.get('/study-program-semesters')
    .then(dropdownMapper).catch(err => {
        console.log('Failed to fetch semester.');
    });

const fetchStudyTypeOptions = () => axios.get('/study-types')
    .then(dropdownMapper).catch(err => {
        console.log('Failed to fetch semester.');
    });

const fetchStudyProgramStudentOptionsByStudyProgramId = (studyProgramId) => axios.get(`/student/${studyProgramId}`)
    .then(dropdownMapper).catch(err => {
        console.log('Failed to fetch study program students.');
    });


// const fetchEntitiesWithDefaultKey = () => axios.get('/entities')
//     .then(res => {
//         const fbihId = res.data.find(el => el._key === 'fbih').id;
//         const entities = res.data.map(el => ({
//             value: el.id,
//             key: el.id,
//             text: ((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).name : el.name)
//         }));
//         return {
//             entities, fbihId
//         };
//     });
//
//
// const fetchGendersWithDefaultKeys = () => axios.get('/genders')
//     .then(res => {
//         const defaultMaleGenderId = res.data.find(el => el._key === 'm').id;
//         const defaultFemaleGenderId = res.data.find(el => el._key === 'f').id;
//         const defaultUndefinedGenderId = res.data.find(el => el._key === 'u').id;
//         const genders = res.data.map(el => ({
//             value: el.id,
//             key: el.id,
//             text: ((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).name : el.name)
//         }));
//         return {
//             genders, defaultMaleGenderId, defaultFemaleGenderId, defaultUndefinedGenderId
//         };
//     });
//
// const fetchRawFaculties = () => axios.get('/graduation-documents/faculties')
//     .then(res => res.data);


export default {

    fetchCommitteeTypes,
    fetchCommitteeMembersByCommitteeId,
    fetchCommitteeCandidatesByCommitteeId,
    addCandidatesToCommitteeByCommitteeId,
    fetchMembersOptions,
    fetchAcademicYears,
    fetchCommittees,
    fetchCommitteeOptions,
    fetchStudyProgramsActive,
    fetchSemesterOptions,
    fetchStudyTypeOptions,
    fetchStudyProgramStudentOptionsByStudyProgramId,
    fetchCandidates,
    createCandidate,
    createCandidateFromUNSA,
    createCommittee,
    fetchCommitteeInfoByCommitteeId,
    fetchCandidateOptions
};



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamEquivalence/Util/request.js